/**
 * Отзыв с модерации
 */

import { apiFetch } from "../api-fetch";
import Toast from "../../components/modal/toast";
import { triggerEvent } from "../helpers/trigger-event";

document.addEventListener("click", e => {
  
  let cancelButton = e.target.closest('[data-cancel-moderation]');
  if (!cancelButton) return;
  
  let cancelUrl = deleter.dataset.action;
  if (!cancelUrl) return;

  window.confirm({
    question: "Статья будет отозвана с модерации. Вы уверены?",
    confirmButton: 'Да!'
  })
  .then(() => {
    apiFetch(cancelUrl, {
      method: "POST"
    })
    .then(response => {
      if (response.success) {
        let item = deleter.closest('[data-delete-item]');
        if (!item) return;

        if (item.hasAttribute('data-delete-redirect')) {
          location = item.getAttribute('data-delete-redirect');
        } else if (item.hasAttribute('data-delete-remove')) {
          triggerEvent(item, "delete");
          item.remove();
        }
      }
    })
    .catch(error => {
      Toast.open(error, {
        state: "error"
      });
      console.error(error);
    });
  })
  .catch((err) => {
    console.error(err)
  })

  

})